import React, { useRef } from "react";
import { createPortal } from "react-dom";
import useModalA11y from "../CustomModal/useModalA11y";
import "./panneau-lateral.scss";

// ============================================================
// Panneau latéral qui s'ouvre par la droite, par-dessus la page : un
// dialogue modal (role="dialog", focus piégé, Échap, clic sur le voile,
// défilement de la page bloqué, focus rendu à l'élément d'origine — le hook
// useModalA11y des modales). Fond `body` pour y poser des cartes, barre de
// titre et pied d'actions sur `surface`.
// - `titre` : nom accessible du dialogue (« Aperçu de PAYET Marie »).
// - `surtitre` : libellé court affiché dans la barre (« Aperçu de la fiche »).
// - `pied` : actions, alignées à droite.
// ============================================================

const PanneauLateral = ({ ouvert, onFermer, titre, surtitre = null, pied = null, children, className = "" }) => {
  const refPanneau = useRef(null);
  useModalA11y({ isOpen: !!ouvert, onClose: onFermer, cardRef: refPanneau });

  if (!ouvert) return null;

  return createPortal(
    <div className={`panneau-lateral-conteneur ${className}`.trim()}>
      <div className="panneau-lateral__voile" onMouseDown={onFermer} aria-hidden="true" />
      <aside ref={refPanneau} className="panneau-lateral" role="dialog" aria-modal="true" aria-label={titre} tabIndex={-1}>
        <div className="panneau-lateral__barre">
          {surtitre && <p className="panneau-lateral__surtitre">{surtitre}</p>}
          <button
            type="button"
            className="panneau-lateral__fermer"
            onClick={onFermer}
            aria-label="Fermer le panneau"
            title="Fermer (Échap)"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="panneau-lateral__corps">{children}</div>
        {pied && <div className="panneau-lateral__pied">{pied}</div>}
      </aside>
    </div>,
    document.body
  );
};

export default PanneauLateral;
